import { useIsMutating } from '@tanstack/react-query';
import Button from 'components/button/Button';
import { Modal } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RESPONSE_SUGGESTION_MUTATION_KEY } from './ViewAirbnbGuestReviewModal.constants';

const ViewAirbnbGuestReviewModalFooter = ({
  handleClose,
  isLoading,
  isRespondActionAllowed,
}: {
  handleClose: () => void;
  isLoading: boolean;
  isRespondActionAllowed: boolean;
}) => {
  const { t } = useTranslation();
  const { isDirty } = useFormState();
  const fetchSuggestionCalls = useIsMutating({
    mutationKey: [RESPONSE_SUGGESTION_MUTATION_KEY],
  });

  const isFetchingResponseSuggestion = fetchSuggestionCalls > 0;

  return (
    <Modal.Footer>
      {isRespondActionAllowed && (
        <Button onClick={handleClose}>{t('common.cancel')}</Button>
      )}
      <Button
        bsStyle="primary"
        onClick={isRespondActionAllowed ? undefined : handleClose}
        type={isRespondActionAllowed ? 'submit' : 'button'}
        disabled={
          (!isDirty && isRespondActionAllowed) ||
          isLoading ||
          isFetchingResponseSuggestion
        }
      >
        {isRespondActionAllowed
          ? t(
              'pageProperty.reviews.airbnbGuest.guestReviews.modal.submitResponse',
            )
          : t('common.close')}
      </Button>
    </Modal.Footer>
  );
};

export default ViewAirbnbGuestReviewModalFooter;
